import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import { ConfirmModal } from "../../boxes/ConfirmModal/ConfirmModal";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import classes from "./BulkInviteSummaryModal.module.scss";

export function BulkInviteSummaryModal({
  isOpen,
  onClose,
  onConfirm,
  eligibleCount,
  totalCount,
  doNotEmailCount,
  firedCount,
  isLoading,
}) {
  const { tClients } = useAppTranslation.Clients();
  const skippedCount = totalCount - eligibleCount;

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={tClients("bulkInvite.summary.title")}
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmTitle={
        isLoading
          ? tClients("bulkInvite.summary.sending")
          : tClients("bulkInvite.summary.sendToEligible", { count: eligibleCount })
      }
      cancelTitle={tClients("bulkInvite.summary.cancel")}
      isConfirming={isLoading}
    >
      <div className={classes.content}>
        <p className={classes.intro}>{tClients("bulkInvite.summary.intro")}</p>

        <div className={classes.statsContainer}>
          <div className={classes.statBox}>
            <div className={cx(classes.statNumber, classes.total)}>{totalCount}</div>
            <div className={classes.statLabel}>{tClients("bulkInvite.summary.totalSelected")}</div>
          </div>

          <div className={classes.statBox}>
            <div className={cx(classes.statNumber, classes.eligible)}>{eligibleCount}</div>
            <div className={classes.statLabel}>{tClients("bulkInvite.summary.eligible")}</div>
          </div>

          {skippedCount > 0 && (
            <div className={classes.statBox}>
              <div className={cx(classes.statNumber, classes.skipped)}>{skippedCount}</div>
              <div className={classes.statLabel}>{tClients("bulkInvite.summary.skipped")}</div>
            </div>
          )}
        </div>

        {skippedCount > 0 && (
          <div className={classes.restrictionsSection}>
            <div className={classes.restrictionsTitle}>
              Blocked patients have the following restrictions:
            </div>

            <div className={classes.restrictionTags}>
              {doNotEmailCount > 0 && (
                <div className={cx(classes.restrictionTag, classes.doNotEmail)}>
                  <i className="fa fa-envelope" />
                  <span>{tClients("bulkInvite.summary.doNotEmail")}</span>
                </div>
              )}

              {firedCount > 0 && (
                <div className={cx(classes.restrictionTag, classes.fired)}>
                  <i className="fa fa-ban" />
                  <span>{tClients("bulkInvite.summary.fired")}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </ConfirmModal>
  );
}

BulkInviteSummaryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  eligibleCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  doNotEmailCount: PropTypes.number.isRequired,
  firedCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
};

BulkInviteSummaryModal.defaultProps = {
  isLoading: false,
};
